import React, { useContext } from "react";
import { useTheme } from "@emotion/react";
import { CcRootContext } from "../conversionCenterRoot";
import { ArrowLeft, Close, Logo } from "./ui-icons";

export const CcLayout = (props) => {
  const theme = useTheme();
  const ctx = useContext(CcRootContext);

  const layoutStyle = {
    backgroundColor: theme.colors.white,
    borderRadius: 10,
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    fontFamily: theme.font.secondary,
    fontSize: theme.f_sizes.base,
    color: theme.colors.font,
    maxHeight: 570,
    maxWidth: 469,
    padding: "15px 25px 10px",
    position: "relative",
    height: ctx.landscape ? ctx.height : "100%",
    width: "100%",
  };

  const navStyle = {
    display: "flex",
    alignItems: "center",
  };

  const buttonBase = {
    backgroundColor: "transparent",
    border: 0,
    color: theme.colors.fontDark,
    cursor: "pointer",
    padding: 0,
    transition: "color .2s ease-in-out",
    "&:hover": {
      color: theme.colors.black,
    },
  };

  const hideButtonStyle = {
    ...buttonBase,
    marginLeft: "auto",
  };

  const footerStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    fontFamily: theme.font.secondary,
    fontSize: theme.f_sizes.xs,
    color: theme.colors.black,
    marginTop: "auto",
    "a": {
      display: "block",
      lineHeight: 1,
      marginTop: 1,
    }
  };

  const handleBackAction = () => {
    return void ctx.updateContext({
      ...ctx,
      history: ctx.history.slice(0, -1),
    });
  };

  return(
    <div css={layoutStyle}>
      <div css={navStyle}>
        {ctx.history.length > 0 && (
          <button
            type="button"
            onClick={handleBackAction}
            css={buttonBase}
          >
            <ArrowLeft />
          </button>
        )}
        <button
          type="button"
          onClick={() => props.toggleVisibility()}
          css={hideButtonStyle}
        >
          <Close />
        </button>
      </div>
      {props.children}
      <p css={footerStyle}>
        powered by <a href="https://jamesamplifier.com/demo/" target="_blank" rel="noopener noreferrer"><Logo /></a>
      </p>
    </div>
  );
};
